

import React, { Fragment, useState } from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoginContext } from "../context/LoginContext";
import { useQuery } from "@tanstack/react-query";
import { getRequest } from "../services/apiMethods";
import DisplayStar from "../Componants/DisplayStar";

export default function ElectricianReviews() {
  const isMobile = window.innerWidth <= 768;
  const Navigate = useNavigate();
  const Location = useLocation()
  const { data: electricianProfileReview } = useQuery({
    queryKey: ["electricianProfileReview"],
    queryFn: () => getRequest(`/profile/review/list${Location?.search}`),
    enabled: !!Location?.search,
  });



  console.log("electricianProfileReview", isMobile)



  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3
              className="with-back-btn cursor-pointer"
              onClick={() => Navigate(-1)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                  fill="black"
                />
              </svg>
              Reviews
            </h3>
          </div>

          {electricianProfileReview && Array.isArray(electricianProfileReview?.data) && electricianProfileReview?.data.length > 0 ? (
            electricianProfileReview.data.map((ele, index) => {
              return (
                <div className="testimonial-container" key={index}>
                  <div className="testimonial-card">
                    <div className="testimonial-header">
                      <div className="user-profile-sec">
                        <div className="user-profile-mainbox">
                          <img
                            src={
                              ele?.customer?.image
                                ? ele.customer.image
                                : require("../assets/images/vector-logo.svg").default
                            }
                            alt="User"
                          />
                        </div>
                        <div className="user-info">
                          <span className="user-name">{ele?.customer?.name}</span>
                          <span className="user-role" style={{ color: "black" }}>
                            {ele?.service?.serviceName}
                          </span>
                        </div>
                      </div>
                      <div className="rating">
                        <DisplayStar rating={ele?.rating || 0} size={isMobile ? 13 : 24} />
                      </div>
                    </div>
                    <div className="testimonial-content">
                      <p>{ele?.comment}</p>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <p style={{ textAlign: "center", color: "gray", marginTop: "1rem" }}>
              No data available
            </p>
          )}

        </Container>
      </Layout>
    </>
  );
}
